var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-tip-pane"},[_c('div',{staticClass:"product-detail-ul"},_vm._l((_vm.tipList),function(item,index){return _c('div',{key:index,staticClass:"product-detail-li"},[(item.isErr)?_c('i',{staticClass:"el-icon-close icon red"}):_c('i',{staticClass:"el-icon-check icon"}),_c('span',[_vm._v(_vm._s(item.text))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }